import './App.css';
import { BrowserRouter as Router, } from 'react-router-dom';
import Header from './components/Header/Header';
import Test from './Test';

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        {/* <Test /> */}
      </Router>
    </div>
  );
}

export default App;
